import React, { useState, useEffect } from 'react';
import './Home3.css';
import logo from '../Images/Logo_Invis.png';
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'


// Import slideshow images
const slideshowImages = [
  require('../Images/HomePageSlideshow/1.png'),
  require('../Images/HomePageSlideshow/2.png'),
  require('../Images/HomePageSlideshow/3.png'),
  require('../Images/HomePageSlideshow/4.png'),
  require('../Images/HomePageSlideshow/9.png'),
  require('../Images/HomePageSlideshow/Home2.png'),
  require('../Images/HomePageSlideshow/Home.png'),
];

function Home3() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousIndex(currentIndex);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slideshowImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div className="home3-container">
      {/* Slideshow Background */}
      <div className="slideshow3-wrapper">
        {slideshowImages.map((img, index) => {
          let className = 'slideshow3-image';
          if (index === currentIndex) {
            className += ' slide-in-right';
          } else if (index === previousIndex) {
            className += ' slide-out-left';
          }

          return (
            <img
              key={index}
              src={img}
              className={className}
              alt={`Slide ${index + 1}`}
            />
          );
        })}
        <div className="slideshow3-overlay" />
      </div>

      {/* Navbar */}
      {/* <nav className="navbar3">
        
        <div className="logo-wrapper">
          <a href='/'>
            <img src={logo} alt="Captain's Connections Logo" className="logo-image" />
          </a>
          
        </div>
        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</div>
        <div className={`nav-links3 ${menuOpen ? 'active' : ''}`}>
          <a href="/services">Our Services In Antigua</a>
          <a href="/destinations">Destinations & Itineraries</a>
          <a href="/connect">Connect with Services</a>
          <button className="contact-button">Contact</button>
        </div>
      </nav> */}
      <Navbar/>

      {/* Info Cards */}
      <section className="info-section3">
        <div className="card3" id="services">
          <h3 className="hover-title">Our Services In Antigua</h3>
          <p>Lorem ipsum dolor sit amet.</p>
          <button className="card3-button">Title 1</button>
        </div>
        <div className="card3" id="itinerary">
          <h3 className="hover-title">Destinations & Itineraries</h3>
          <p>Lorem ipsum dolor sit amet.</p>
          <button className="card3-button">Title 2</button>
        </div>
        <div className="card3" id="connect">
          <h3 className="hover-title">Connect with Services</h3>
          <p>Lorem ipsum dolor sit amet.</p>
          <button className="card3-button">Title 3</button>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="site-footer">
        <div className="footer-nav">
            <a href="/services">Our Services In Antigua</a>
            <a href="/destinations">Destinations & Itinerary</a>
            <a href="/connect">Conenect With Services</a>
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <p>Feel free to <a href="/contact">Contact Us</a>.</p>
          </div>
          <a href='/'>
              <img src={logo} alt="Captain’s Connections Logo" className="footer-logo-image" />
          </a>
        </div>
      </footer> */}
      <Footer/>
    </div>
  );
}

export default Home3;
